export const PRESALE_MINT_COPY = (quantity: number) =>
  `Reward your collectors with presale access. The Presale Mint must occur before your Public Mint, and the price per edition must be less than or equal to the price of your Public Mint. Allowlisted wallets will be able to mint ${quantity} edition${
    quantity > 1 ? 's' : ''
  } each.`;

export const PUBLIC_MINT_COPY = (quantity: number) =>
  `Anyone can purchase your release during the Public Mint. Each wallet can purchase up to ${quantity} edition${
    quantity > 1 ? 's' : ''
  } each.`;
export const DROP_CONFIG_SUBHEADER = 'Configure and customize your drop sale.';

export const DROP_CONFIG_EDUCATION_TEXT =
  "You can't edit drop type and add or remove a Presale after uploading. Everything else can be edited up until each sale ends.";

export const DROP_CONFIG_EDUCATION_TEXT_V2 = 'Drop type and phases cannot be edited once started.';
